// Owner 2026-11-03: one sitewide range. Setup $150–$250 (jig, proof and
// test; counts toward the job), then $20–$30 per piece; rush +50%.
const uvPrintingProductionRanges = [
  {
    label: 'Per piece',
    price: '$20–$30 each',
    note: 'Typical per-piece printing after setup. Large, multi-side or full-wrap items are quoted per project.',
  },
]

const uvPrintingPriceFactors = [
  'Quantity',
  'Item & print size',
  'Artwork variations',
  'Print locations',
  'Surface preparation',
  'Fixtures & handling',
]

const uvPrintingPricing = {
  setupFee: '$150–$250',
  // Top of the setup range, used for worked budget examples and schema.
  setupFeeAmount: '250',
  setupFeeFrom: '150',
  setupLabel: 'setup, jig, proof and test',
  rush: '+50%',
  ranges: uvPrintingProductionRanges,
  factors: uvPrintingPriceFactors,
  shortRunAnswer:
    'At PrintAWorld, smaller UV-printing orders typically have a higher production cost per piece because each batch requires dedicated machine time and handling. The setup fee is separate and is also spread across fewer items. Quantity can affect both parts of the price; a lower production rate is not automatic at a particular order size.',
  faqAnswer:
    'UV printing has a $150–$250 setup that covers the jig, proof and test and counts toward the job, then $20–$30 per piece. Rush adds 50%. These are planning ranges, not fixed quotes: item size, print size, quantity, artwork variations, surface, placement and handling can change the price. Large, multi-side or full-wrap items are quoted per project. Reusing an existing jig or a proven setup from similar work keeps the setup at the low end of the range. Rush work is quoted after we review capacity and the in-hand date.',
}

module.exports = {
  uvPrintingPricing,
  uvPrintingProductionRanges,
  uvPrintingPriceFactors,
}
